var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ib-card',{staticClass:"ib-card-empty-chart d-flex flex-column",attrs:{"animation":false}},[_c('span',{staticClass:"card-title font-outfit-light"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-img',{staticClass:"placeholder-image",attrs:{"contain":"","src":_vm.placeholderImage,"alt":"placeholder-image","aspect-ratio":16/9}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }